module.exports = ".large-checkbox {\n  width: 12px;\n  height: 12px;\n}\n.ui-editable-column {text-decoration: underline !important; cursor: pointer; color: #e66c36;}\n.use-my-acc-num {\n  font-size: small;\n  text-decoration: none;\n}\n.use-my-acc-num:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n:host ::ng-deep li.ui-state-active {\n  background-color: #186ba0 !important;\n  font-weight: bold !important;\n  color: #fff !important;\n}\n:host ::ng-deep .ui-tabview .ui-tabview-panel {\n  padding: 10px 5px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-users/my-team/my-team.component.css
// module id = ./src/app/manage-users/my-team/my-team.component.css
// module chunks = main